var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * MessageAlert component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconMessageAlert extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon cat-c-icon-bi-directional', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.2427 2.60498C16.502 2.60498 15.0908 4.01614 15.0908 5.7569C15.0908 7.49766 16.502 8.90883 18.2427 8.90883C19.9835 8.90883 21.3947 7.49766 21.3947 5.7569C21.3947 4.01614 19.9835 2.60498 18.2427 2.60498ZM13.5908 5.7569C13.5908 3.18772 15.6736 1.10498 18.2427 1.10498C20.8119 1.10498 22.8947 3.18772 22.8947 5.7569C22.8947 8.32609 20.8119 10.4088 18.2427 10.4088C15.6736 10.4088 13.5908 8.32609 13.5908 5.7569Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.97605 2.60498C4.76102 2.60498 4.55479 2.6904 4.40275 2.84245C4.2507 2.9945 4.16528 3.20072 4.16528 3.41575V17.4627C4.16528 17.5433 4.15228 17.6234 4.12679 17.6998L2.99807 21.086L7.91568 19.8566C7.97517 19.8417 8.03626 19.8342 8.09758 19.8342H20.5837C20.7988 19.8342 21.005 19.7488 21.157 19.5967C21.3091 19.4447 21.3945 19.2385 21.3945 19.0234V13.5608C21.3945 13.1465 21.7303 12.8108 22.1445 12.8108C22.5587 12.8108 22.8945 13.1465 22.8945 13.5608V19.0234C22.8945 19.6363 22.6511 20.2241 22.2177 20.6574C21.7843 21.0908 21.1966 21.3342 20.5837 21.3342H8.18991L2.03641 22.8726C1.77085 22.939 1.49021 22.8554 1.30422 22.6546C1.11823 22.4537 1.05643 22.1675 1.143 21.9078L2.66528 17.341V3.41575C2.66528 2.8029 2.90873 2.21514 3.34209 1.78179C3.77544 1.34844 4.36319 1.10498 4.97605 1.10498H9.65835C10.0726 1.10498 10.4084 1.44077 10.4084 1.85498C10.4084 2.26919 10.0726 2.60498 9.65835 2.60498H4.97605Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconMessageAlert.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconMessageAlert.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconMessageAlert.prototype, "size", void 0);
if (customElements.get('cat-icon-message-alert') === undefined) {
    customElements.define('cat-icon-message-alert', BlocksIconMessageAlert);
}
